export default {
  message: {
    "error": "अरे! कुछ गलत हो गया।",
    "Sorrysomeerrorsoccurred": "एक अप्रत्याशित त्रुटि हुई। आप भाषा बदलने की कोशिश कर सकते हैं या ऐप को बंद करके फिर से शुरू कर सकते हैं।",
    "quit": "बंद करें",
    "language": "भाषा",
    "Youcanchangethelanguagehere": "आप यहाँ भाषा बदल सकते हैं!",
    "current": "वर्तमान",
    "home": "मुख्य पृष्ठ",
    "friends": "दोस्त",
    "wallet": "वॉलेट",
    "aboutus": "हमारे बारे में",
    "Sharewithfriends": "दोस्तों के साथ साझा करें",
    "copyFailure": "कॉपी असफल",
    "copySuccess": "कॉपी सफल",
    "Claimreward": "इनाम प्राप्त करें",
    "DailyLogin": "दैनिक लॉगिन",
    "noInvitationsYet": "अभी तक कोई आमंत्रण नहीं",
    "LoadMore": "और लोड करें",
    "WatchAD": "विज्ञापन देखें",
    "continue": "जारी रखें",
    "Congratulations": "बधाई हो",
    "MyFriends": "मेरे दोस्त",
    "Invitefriends": "दोस्तों को आमंत्रित करें",
    "Invitepremiumfriends": "प्रीमियम दोस्तों को आमंत्रित करें",
    "DailyTasks": "दैनिक कार्य",
    "inviteDesc": "प्रत्येक दोस्त के लिए +{num} ${name}",
    "DailyTasksDesc": "ज्यादा एयरड्रॉप पाने के लिए कार्य पूरा करें",
    "SponsorsandPartners": "प्रायोजक और भागीदार",
    "Receivingwallet": "प्राप्ति वॉलेट",
    "Enterwalletaddress": "{name} वॉलेट पता दर्ज करें",
    "Claim": "कलेक्ट",
    "Booster": "बूस्टर",
    "RentPeriod": "किराये की अवधि",
    "days30": "30 दिन",
    "Dailyprofit": "दैनिक लाभ",
    "Totalprofit": "कुल लाभ",
    "Quantity": "मात्रा",
    "RentPrice": "किराया मूल्य",
    "RentMiner": "खनन किराए पर लें",
    "Insufficient": "पर्याप्त आमंत्रित लोग नहीं हैं",
    "InsufficientMsg": "आपको अधिक एक्सेसरीज़ कमाने के लिए {num} दोस्तों को आमंत्रित करना होगा।",
    "Settings": "सेटिंग्स",
    "copyid": "आईडी कॉपी करें",
    "UpgradeSuccessfully": "सफलता से सुधारें",
    "Name": "नाम",
    "userinfo": "उपयोगकर्ता जानकारी",
    "disconnect": "अलग करें",
    "Startmining": "खनन शुरू करें",
    "Welcome": "आपका स्वागत है {name}",
    "Withdrawal": "निकासी",
    "Minimumamount": "न्यूनतम राशि",
    "Networkfee": "नेटवर्क शुल्क",
    "Enteramount": "राशि दर्ज करें",
    "Submit": "प्रस्तुत करें",
    "MinimumTip": "निकासी राशि बहुत छोटी है। न्यूनतम निकासी राशि: {num}",
    "MaximumTip": "अपर्याप्त राशि, अधिकतम राशि जिसे आप निकाल सकते हैं: {num}",
    "SubmittedTip": "प्रस्तुत कर दिया गया, 30-60 कार्य दिवसों के भीतर प्रक्रिया होने की उम्मीद है",
    "WebSubmittedTip": "प्रस्तुत कर दिया गया, हम इसे जल्द से जल्द प्रक्रिया करेंगे।",
    "WithdrawStatus": "स्थिति",
    "Submissiontime": "प्रस्तुति समय",
    "WithdrawAwaitTip": "* यह अनुमानित 30-60 कार्य दिवसों में लगेगा। अधिक दोस्तों को आमंत्रित करने से समीक्षा प्रक्रिया में तेजी आ सकती है।",
    "WebWithdrawAwaitTip": "* यह अनुमानित 24-48 घंटों में लगेगा। अधिक दोस्तों को आमंत्रित करने से समीक्षा प्रक्रिया में तेजी आ सकती है।",
    "Processing": "प्रसंस्करण",
    "Success": "सफलता",
    "Rejection": "अस्वीकृति",
    "Amount": "राशि",
    "Numberoffriends": "दोस्तों की संख्या: {now}/{limit}",
    "InviteTip": "अपनी पहली निकासी करने के लिए, आपको {limit} दोस्तों को खनन ऐप में शामिल करने के लिए आमंत्रित करना होगा।",
    "openonphone": "अपने फोन पर इस लिंक को खोलें।",
    "claimTip": "जिस राशि को प्राप्त करना है वह बहुत छोटी है। प्राप्त करने के लिए न्यूनतम राशि: {num}",
    "WalletBalance": "वॉलेट बैलेंस",
    "Withdraw": "निकासी",
    "SetWalletAddress": "वॉलेट पता सेट करें",
    "WithdrawalRecord": "निकासी रिकॉर्ड",
    "Norecords": "कोई रिकॉर्ड नहीं",
    "Whatis": "{name} क्या है?",
    "All": "सभी",
    "save": "सहेजें",
    "successWithdrawal": "स्कैन सफल {num}",
    "secondsago": "{time} सेकंड पहले",
    "Loading": "लोड हो रहा है...",
    "PaymentConfirming": "लेन-देन की स्थिति की जांच कर रहे हैं...",
    "Check": "जांचें",
    "CheckFail": "लेन-देन पूरा नहीं हुआ। कृपया 5 सेकंड बाद फिर से जांचें।",
    "Addname": "'{name}' को अपने नाम में जोड़ें",
    "Restattcheck": "चेक करने के लिए ऐप को फिर से शुरू करें",
    "Copyname": "'{name}' कॉपी करें",
    "SubmissionFailed": "प्रस्तुति विफल रही, कृपया बाद में पुनः प्रयास करें",
    "WithdrawalReview": "निकासी समीक्षा",
    "select_payment_method": "भुगतान विधि चुनें",
    "total_amount": "कुल राशि",
    "next_step": "अगला कदम",
    "creating_order": "ऑर्डर बनाना...",
    "order_created": "ऑर्डर बनाया गया",
    "order_status": "ऑर्डर स्थिति",
    "order_id": "ऑर्डर आईडी",
    "order_amount": "ऑर्डर राशि",
    "order_status_desc": "ऑर्डर स्थिति विवरण",
    "payment_cancelled": "भुगतान रद्द कर दिया गया",
    "opening_payment": "भुगतान खोलना...",
    "payment_success": "भुगतान सफल",
    "payment_failed": "भुगतान असफल",
    "payment_pending": "भुगतान लंबित",
    "payment_processing": "भुगतान प्रक्रिया में",
    "create_order_failed": "ऑर्डर बनाने में असफल",
    "creating_ton_order": "TON ऑर्डर बना रहे हैं...",
    "check_payment_status": "भुगतान स्थिति की जांच कर रहे हैं...",
    "use_ton_payment": "TON भुगतान का उपयोग करें",
    "connect_wallet": "वॉलेट जोड़ें",
    "start_transaction": "लेनदेन शुरू करें",
    "address": "पता",
    "amount_ton": "राशि TON",
    "copy": "प्रतिलिपि",
    "comment_memo": "टिप्पणी ज्ञापन",
    "comment_memo_desc": "कृपया टिप्पणी ज्ञापन दर्ज करें",
    "comment_memo_placeholder": "टिप्पणी ज्ञापन दर्ज करें",
    "amount": "राशि",
    "wallet_address": "वॉलेट पता",
    "you_can_choose_to_connect_wallet_to_pay": "आप भुगतान करने के लिए वॉलेट जोड़ने का चयन कर सकते हैं",
    "or_manually_transfer_to_the_above_address": "या ऊपर दिए गए पते पर मैन्युअल रूप से स्थानांतरित करें (ध्यान दें कि राशि और ज्ञापन बिल्कुल समान होना चाहिए)",
    "transaction_success": "लेनदेन सफल",
    "transaction_failed": "लेनदेन असफल",
    "transaction_error": "लेनदेन त्रुटि",
    "transaction_status": "लेनदेन स्थिति",
    "transaction_id": "लेनदेन आईडी",
    "transaction_amount": "लेनदेन राशि",
    "transaction_status_desc": "लेनदेन स्थिति विवरण",
    "miner_detail": "खनन विवरण",
    "rent_period": "भाड़े की अवधि",
    "days": "{days} दिन",
    "daily_yield": "दैनिक उपज",
    "total_yield": "कुल उपज",
    "invite_friends": "मित्रों को आमंत्रित करें",
    "price": "कीमत",
    "rent": "भाड़ा",
    "free_claim": "समान प्राप्त करें",
    "redeem": "भुनाएं",
    "buy": "भाड़ा",
    "invite_friends_not_enough": "मित्रों को आमंत्रित करना पर्याप्त नहीं है",
    "redeem_success": "भुनाने में सफल",
    "redeem_failed": "भुनाने में असफल",
    "rent_success": "भाड़ा सफल",
    "rent_failed": "भाड़ा असफल",
    "TotalPower": "कुल शक्ति",
    "MaxQuantity": "अधिकतम मान प्राप्त हुआ",
    "Running": "चल रहा है",
    "Stop": "रोकें",
    "Withdrawalunlock": "निकासी अनलॉकिंग",
    "Close": "बंद करें",
    "Delivering": "डिलिवर कर रहे हैं",
    "Duetothelargenumber": "प्राप्तकर्ताओं की बड़ी संख्या के कारण, आपका एयरड्रॉप 15-20 कार्य दिवसों में आने की उम्मीद है",
    "WithdrawalunlockTip": "आपको निकासी अनलॉक करने के लिए कार्यों को पूरा करने/बाइंड वॉलेट्स के लिए {num} आमंत्रित मित्रों की आवश्यकता है",
    "mining_title": "रोबोट",
    "Upgrade": "अपग्रेड करें",
    "partner": "भागीदार",
    "faq": "अक्सर पूछे जाने वाले प्रश्न",
    "task": "कार्य",
    "OpenRobot": "रोबोट खोलें",
    "MyRobot": "मेरा रोबोट",
    "Level": "स्तर",
    "Commission": "कमीशन",
    "DirectFriends": "प्रत्यक्ष मित्र",
    "Feedback": "प्रतिपुष्टि",
    "Pleaseenteryouremailaddress": "कृपया अपना ईमेल पता दर्ज करें",
    "Inputfeedbackcontent": "प्रतिपुष्टि सामग्री इनपुट करें",
    "Submitfeedback": "प्रतिपुष्टि सबमिट करें",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "प्रतिपुष्टि सफलतापूर्वक सबमिट की गई, आपके मूल्यवान प्रतिपुष्टि के लिए धन्यवाद",
    "Feedbacksubmissionfailed,pleaseretriy": "प्रतिपुष्टि सबमिशन में विफल, कृपया पुन: प्रयास करें",
    "Addressformaterror": "पता प्रारूप त्रुटि",
    "Readclipboardfailed": "क्लिपबोर्ड पढ़ने में विफल",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "आपने आज पहले ही प्रतिपुष्टि दी है, कृपया कल वापस आएं",
    "Record": "रिकॉर्ड",
    "Newuserguidance": "स्वागत यात्रा देखें",
    "Usetonwallet": "TON वॉलेट का उपयोग करें",
    "Reward": "इनाम",
    "Connectwallet": "वॉलेट कनेक्ट करें",
    "Notconnected": "असंलग्न",
    "Disconnect": "अलग करें",
    "AboutTAI": "टोकन विवरण",
    "WithdrawalRecordDesc": "निकासी रिकॉर्ड",
    "StartAItrading": "AI ट्रेडिंग शुरू करें",
    "Next": "अगला",
    "Start": "शुरू करें",
    "WithdrawalSuccess": "निकासी सफल",
    "WithdrawalFail": "निकासी विफल",
    "Max": "अधिकतम",
    "WithdrawalRecords": "निकासी रिकॉर्ड",
    "Commissionrules": "कमिशन के नियम",
    "Mycommission": "मेरा कमिशन",
    "Shop": "शॉप",
    "BuyDifferentAIrobots": "तेज़ स्कैन के लिए कंप्यूट उपकरणों के साथ उन्नयन करें!",
    "CurrentRunningAIrobots": "वर्तमान चल रहे एआई रोबोट्स",
    "DailyProfit": "दैनिक लाभ",
    "Buy": "खरीदें",
    "ValidityPeriod": "वैधता अवधि",
    "Days": "दिन",
    "Price": "कीमत",
    "APY": "APY",
    "NoRobot": "कोई कंप्यूट शक्ति नहीं",
    "RemainingTime": "शेष समय",
    "InviteandEarn": "आमंत्रित करें और कमाएँ",
    "InvitDec": "अपने दोस्तों को एआई ट्रेडिंग में शामिल होने के लिए आमंत्रित करें और यूएसडीटी कमीशन और एयरड्रॉप टोकन एक साथ कमाएँ!",
    "ShareToGroups": "समूहों में साझा करें",
    "Select_payment_method": "भुगतान विधि चुनें",
    "twa_pay_tip_with_memo": "कृपया सुनिश्चित करें कि पते, राशि और मेमो ट्रांसफर के लिए संगत हैं।",
    "twa_pay_tip": "कृपया सुनिश्चित करें कि पता और राशि ट्रांसफर के लिए सही हैं।",
    "twa_pay_tip_placeholder": "टिप्पणी मेमो दर्ज करें",
    "twa_pay_tip_placeholder_with_memo": "मेमो के साथ टिप्पणी मेमो दर्ज करें",
    "twa_pay_tip_placeholder_without_memo": "बिना मेमो टिप्पणी मेमो दर्ज करें",
    "twa_pay_tip_placeholder_with_memo_placeholder": "मेमो के साथ टिप्पणी मेमो दर्ज करें",
    "twa_pay_tip_placeholder_without_memo_placeholder": "बिना मेमो टिप्पणी मेमो दर्ज करें",
    "realtime_ai": "वास्तविक समय एआई ट्रेडिंग",
    "check_transaction_status": "लेनदेन की स्थिति जांचें",
    "transaction_wait": "लेनदेन प्रक्रिया में है। आप ऐप से बाहर निकल सकते हैं। यह पूरा होने पर आपको एक संदेश सूचित करेगा।",
    "Pleaseenteravalidemailaddress": "कृपया एक मान्य ईमेल पता दर्ज करें",
    "max_robot_tip": "खरीद सीमा प्राप्त हो गई — व्यापार जारी रखने के लिए एक और योजना का प्रयास करें!",
    "connectFailure": "वॉलेट कनेक्ट करने में विफल",
    "connectSuccess": "वॉलेट सफलतापूर्वक कनेक्ट हुआ",
    "PayNow": "अब भुगतान करें",
    "min_withdrawal_amount": "न्यूनतम निकासी राशि {num} {coin_name} है",
    "max_withdrawal_amount": "अधिकतम निकासी राशि {num} {coin_name} है",
    "balance_not_enough": "इस निकासी के लिए आपके पास पर्याप्त शेष राशि नहीं है।",
    "Numberofgroups": "समूहों की संख्या: {now}/{limit}",
    "Withdraw_success": "निकासी सफल",
    "allProfit": "कुल लाभ",
    "AnnualProfit": "वार्षिक लाभ",
    "ScanWallet": "वॉलेट स्कैन करें",
    "wallet_check": "wallet_check",
    "Found": "पाया गया",
    "ScanSpeed": "स्कैन गति",
    "MyComputingPower": "कंप्यूट",
    "Scanning": "स्कैनिंग!",
    "WithdrawDetail": "निकासी विवरण",
    "ScanSuccess": "आपकी स्कैन सफलता दर बढ़ गई है!",
    "TaskDescription": "कार्य पूरे करें ताकि आपकी स्कैन सफलता दर बढ़ सके!",
    "InitializingMiningSystem": "स्कैन सिस्टम प्रारंभ हो रहा है...",
    "NoWithdrawalRecord": "कोई निकासी रिकॉर्ड नहीं",
    "Invite": "आवश्यक निमंत्रण",
    "Free": "मुफ्त",
    "Confirm": "पुष्टि करें",
    "RefreshTasks": "कार्यॉं को ताज़ा करें",
    "NumberofGroups": "समूहों की संख्या: {now}/{limit}",
    "SendMessage": "संदेश भेजें",
    "NumberofShares": "शेयरों की संख्या: {now}/{limit}",
    "NumberofTasks": "कार्य की संख्या: {now}/{limit}",
    "CompleteTask": "कार्य पूरा करें",
    "Accelerated": "त्वरित",
    "Accelerated_withdrawals_success": "त्वरित निकासी सफलतापूर्वक",
    "GoBuy": "खरीदें",
    "SpeedUpScan": "गति बढ़ाएँ",
    "Earnings": "कमाई",
    "learnMore": "और जानें",
    "claimSuccess": "इनाम प्राप्त हुआ",
    "claimFailed": "इनाम प्राप्त करने में विफल, कृपया फिर से प्रयास करें",
    "noDividends": "प्राप्त करने के लिए कोई लाभांश नहीं",
    "dividendsInfoFallback": "रेफरल इनाम कमाने के लिए दोस्तों को आमंत्रित करें"
}};